import { type ReactNode, useRef } from 'react';

import { type Store, createStore } from '../../../core/store/store.js';
import { PieChartStateContext } from '../context/PieChartStateContext.js';
import { initialState, type PieChartState } from '../types/state.js';

export const StoreProvider = ({ children }: { children: ReactNode }) => {
  const storeRef = useRef<Store<PieChartState> | null>(null);

  storeRef.current = createStore({
    ...initialState,
  });

  return (
    <PieChartStateContext.Provider value={storeRef.current}>
      {children}
    </PieChartStateContext.Provider>
  );
};
